export enum ColorCodes {
    ANTI_FLASH_WHITE = "#F0F1F2",
    OUTER_SPACE_GREY = "#434C54",
    WHITE = "#FFFFFF",
    SILVER_SAND_GREY = "#BBC0C1",
    PASTEL_BLUE = "#AED2CE",
    DARK_BLUE = "#25303E"
}